<div
  tabindex="0"
  class="feedback-fade feedback-container {{
    smartFeedbackActive ? 'show' : ''
  }}">
  <div
    class="feedback-title text-center d-flex align-items-center justify-content-between">
    <div class="ps-0 text-start"></div>
    <div>Smart Feedback</div>
    <div class="text-end pe-0">
      <i
        (click)="toggleSmartFeedback()"
        title="hide-icon"
        role="button"
        class="bi bi-arrow-bar-right me-2 p-2"></i>
    </div>
  </div>
  <div class="card-tools d-flex justify-content-end me-3 p-3">
    <div class="me-4">
      Smart Feedback is visible only to the session owner and is designed to
      help you efficiently provide meaningful feedback to participants.
    </div>
    <a
      routerLink="/dashboard/smart-feedback"
      ngbTooltip="See all smart feedback"
      class="text-primary see-all">
      See All
      <i class="ps-1 bi bi-box-arrow-up-right"></i>
    </a>
  </div>
  <div class="feedback-body">
    <ng-container *ngIf="instantFeedbackEnabled">
      <app-card-smart-feedback [hideCollapseIcon]="true" />
    </ng-container>
  </div>
</div>
